import {
    Search,
    Filter,
    RotateCcw,
    Store,
    CreditCard,
    Package,
} from "lucide-react";

import "./OrderFilterBar.css";

function OrderFilterBar({
    orders,
    filters,
    setFilters,
}) {

    const providers = [
        ...new Set(
            orders
                .map(order => order.providerSnapshot?.businessName)
                .filter(Boolean)
        ),
    ];

    const resetFilters = () => {

        setFilters({

            search: "",

            status: "",

            payment: "",

            provider: "",

        });

    };

    return (

        <div className="order-filter-card">

            <div className="filter-title">

                <Filter size={20} />

                <h3>Filter Orders</h3>

            </div>

            <div className="order-filter-grid">

                <div className="filter-input">

                    <Search size={18} />

                    <input
                        type="text"
                        placeholder="Search Order, Customer or Provider..."
                        value={filters.search}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                search: e.target.value,
                            })
                        }
                    />

                </div>

                <div className="filter-select">

                    <Package size={18} />

                    <select
                        value={filters.status}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                status: e.target.value,
                            })
                        }
                    >

                        <option value="">All Status</option>

                        <option value="Pending">Pending</option>

                        <option value="Accepted">Accepted</option>

                        <option value="Preparing">Preparing</option>

                        <option value="Ready For Pickup">
                            Ready For Pickup
                        </option>

                        <option value="Assigned">
                            Assigned
                        </option>

                        <option value="Picked Up">
                            Picked Up
                        </option>

                        <option value="Out For Delivery">
                            Out For Delivery
                        </option>

                        <option value="Delivered">
                            Delivered
                        </option>

                        <option value="Rejected">
                            Rejected
                        </option>

                    </select>

                </div>

                <div className="filter-select">

                    <CreditCard size={18} />

                    <select
                        value={filters.payment}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                payment: e.target.value,
                            })
                        }
                    >

                        <option value="">Payment</option>

                        <option value="Pending">Pending</option>

                        <option value="Paid">Paid</option>

                        <option value="Failed">Failed</option>

                        <option value="Refunded">Refunded</option>

                    </select>

                </div>

                <div className="filter-select">

                    <Store size={18} />

                    <select
                        value={filters.provider}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                provider: e.target.value,
                            })
                        }
                    >

                        <option value="">
                            All Providers
                        </option>

                        {providers.map((provider) => (

                            <option
                                key={provider}
                                value={provider}
                            >
                                {provider}
                            </option>

                        ))}

                    </select>

                </div>

                <button
                    className="reset-filter-btn"
                    onClick={resetFilters}
                >

                    <RotateCcw size={18} />

                    Reset

                </button>

            </div>

        </div>

    );

}

export default OrderFilterBar;